export const formatToLocalDate = (utcDate) => {
    if (!utcDate) return "-";

    return new Date(utcDate).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
    });
};
